
import React from "react";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const currentVersion = import.meta.env.PACKAGE_VERSION || '1.0.4';

  return (
    <footer className="footer">
      <div className="d-sm-flex justify-content-center justify-content-sm-between align-items-center">
        <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">
          © {new Date().getFullYear()} Rutex C.A. {t('copyright_text', 'Todos los derechos reservados.')} | {t('system_version_title', { version: currentVersion, defaultValue: `Sistema de Gestión Comercial v${currentVersion} por Alpinca y Lácteos Danny` })}
        </span>
        <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center text-muted small">
          {t('system_tagline', 'Rutex System • Plataforma Empresarial de Distribución')}
        </span>
      </div>
    </footer>
  );
}

export default Footer;